import { apiRequest } from '../../Utils/apiClient';
import { ADD_COMPROBANTE_CLIENTE_FILE } from '../../Utils/constants';

const postComprobanteGasto = async (formData: FormData) => {
  return apiRequest<void>('post', ADD_COMPROBANTE_CLIENTE_FILE, formData);
};

export { postComprobanteGasto };
